import React, { Component, useEffect } from "react";
import { connect } from "react-redux";

import Dashboard from "../../pages/Dashboard";
import SignInContainer from "../SignInContainer";
import { Navigate } from "react-router-dom";

const DashboardContainer = (props) => {
  if (props.user && localStorage.getItem("token")) {    //because we delete token when it is expired
    if (props?.companyDataValid === "true") return <Dashboard user={props.user} taxes={props.taxes} />
    else return <Navigate to={"projects"} />;        //show projects page if there is no valid accounting data
  } else {
    return <SignInContainer />;
  }
};

const mapStateToProps = (state) => ({
  companyDataValid: state.appState.companyDataValid,
  user: state.user,
  taxes: state.taxes,
});

export default connect(mapStateToProps)(DashboardContainer);
